<section class="site-products">
  <iot-platform-ui-panel
    [buttonTooltip]="'SITES.PRODUCTS.ADD' | translate"
    [hasButton]="false"
    [title]="'SITES.PRODUCTS.PANEL_TITLE' | translate"
    [withCustomAction]="true"
    class="mt-4 mb-4"
  >
    <div fxFlexLayout="row" fxLayoutAlign="center center" panelCustomAction>
      @if (productsBySite?.length > 4 || (productsBySite?.length > 3 && hasProducts && canAddProduct)) {
        <div
          [matTooltip]="(horizontalLayout ? 'PANELS.TOOLTIPS.HORIZONTAL_LAYOUT' : 'PANELS.TOOLTIPS.VERTICAL_LAYOUT') | translate"
          class="panel-button app-round-button"
          matTooltipClass="regular-tooltip"
        >
          <button (click)="horizontalLayout = !horizontalLayout" fxHide.lt-md mat-icon-button>
            <mat-icon>{{ horizontalLayout ? 'apps' : 'swap_horiz' }}</mat-icon>
          </button>
        </div>
      }
      @if (!loading && canUpdateSite && canAddProduct && hasProducts) {
        <div [matTooltip]="'SITES.PRODUCTS.ADD' | translate" class="panel-button app-round-button" matTooltipClass="regular-tooltip">
          <ng-container *ngTemplateOutlet="productsContextMenu"></ng-container>
        </div>
      }
    </div>

    @if (loading) {
      <div fxFlexLayout="row" fxLayoutAlign="center center" panelGrid style="width: 100%">
        <mat-progress-spinner [diameter]="50" color="accent" mode="indeterminate"></mat-progress-spinner>
      </div>
    } @else if (!hasAssignedProducts && !hasProducts) {
      <ng-container panelGrid>
        <div class="no-data-message" fxFlexAlign="center center" fxFlexLayout="row">
          <p>{{ 'SITES.PRODUCTS.NO_PRODUCTS' | translate }}</p>
        </div>
      </ng-container>
    } @else {
      <iot-platform-ui-cards-container [horizontalLayout]="horizontalLayout" panelGrid>
        @for (product of productsBySite; track product.id) {
          <oyan-ui-product-card
            (dispatchEvent)="onDispatchEvent($event)"
            [element]="product"
            [withMenu]="canUpdateSite && canDeleteProduct"
            class="card-xs"
            fxFlex.lt-md="100%"
          ></oyan-ui-product-card>
        }
        @if (canUpdateSite && canAddProduct && hasProducts) {
          <iot-platform-ui-default-card
            [backgroundClass]="'h-100'"
            [title]="'SITES.PRODUCTS.ADD' | translate"
            [withCustomButton]="true"
            [icon]="'add'"
            class="card-xs"
            fxFlex.lt-md="100%"
          >
            <ng-container *ngTemplateOutlet="productsContextMenu" cardCustomButton></ng-container>
          </iot-platform-ui-default-card>
        }
      </iot-platform-ui-cards-container>
    }
  </iot-platform-ui-panel>
</section>

<ng-template #productsContextMenu>
  @if (hasProducts) {
    <oyan-ui-mat-menu-list
      (clear)="onClearFilter()"
      (search)="onApplyFilter($event)"
      (selectItem)="onAddProduct($event)"
      [data]="filteredProducts$ | async"
      displayKey="name"
      noDataMessage="SITES.PRODUCTS.NO_PRODUCTS"
      placeholder="SITES.PRODUCTS.FILTER_PRODUCTS"
    ></oyan-ui-mat-menu-list>
  }
</ng-template>
